<template>
  <b-card>
    <!-- form -->
    <b-form @submit.prevent="postData">


      <div v-for="item in NotificationsList" :key="item.id">
        <b-row>
          <b-col cols="2">
            <div><span>{{ item.name }}</span></div>
          </b-col>
          <b-col cols="2">


            <b-form-checkbox :id="String('web' + item.id)" :name="item.name" value="true" unchecked-value="false"
              :checked="item.web" @change="editToNotificationList(item.id, item.name, 'web', $event)">
              {{$t('web')}}
            </b-form-checkbox>
          </b-col>
          <b-col cols="2">
            <b-form-checkbox :id="String('mail-' + item.id)" :name="'mail-' + item.name" value="true"
              unchecked-value="false" :checked="item.mail"
              @change="editToNotificationList(item.id, item.name, 'mail', $event)">
              {{$t('Email')}}
            </b-form-checkbox>
          </b-col>

          <!-- <b-col cols="2">
            <b-form-checkbox :id="item.id" :name="item.name" value="true" unchecked-value="false">
              mail
            </b-form-checkbox>
          </b-col> -->
        </b-row>
      </div>






      <!-- buttons -->
      <b-col cols="12">
        <b-button :disabled="disable" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mt-1 mr-1"
          type="submit">
          {{ $t('Change Notifications Settings') }}
        </b-button>
      </b-col>
      <!--/ buttons -->

    </b-form>
  </b-card>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BInputGroup, BInputGroupAppend, BFormCheckbox
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'
import store from '@/store'

import axios from '@/libs/axios'
import useAccountSettings from './useAccountSettings'
import { editList } from 'autoprefixer/lib/utils'
import useHelpers from '@/views/modules/useHelpers'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox
  },
  props: {
    passwordPost: {
      type: Function
    },
    errors: {
      type: Object
    }
  },
  directives: {
    Ripple,
  },
  data() {
    return {

      notifications: []

    }
  },



  setup(props, { root }) {
    const disable = ref(true);
    const { toaster } = useHelpers(root)
    const { NotificationsList, postNotificationSetting } = useAccountSettings(root)

    let editedList = NotificationsList;

    let out = [];
    const editToNotificationList = (id, name, type, value) => {
            out = [];
      disable.value = false;
      editedList.value.map((n) => {
        if (id == n.id) {     
          if (type == "web") {    
            n.web = (String(value) == "true")
          } else if (type == "mail") {
            n.mail = (String(value) == "true")
          }
        }
        out.push({ "name": n.name, "id": n.id, "web": n.web, "mail": n.mail });

      })
          }


    const postData = () => {

      postNotificationSetting({ "notifications": out })


    }



    return {
      NotificationsList,
      editToNotificationList,
      postData,
      disable

    }

  }
}
</script>

<style lang="scss">
.invalid {
  border-radius: 0.357rem;
  border: 1px solid #ea5455 !important;

  svg {
    color: #ea5455;
  }
}
</style>
